import React, { useState } from 'react';
import "./navBar.css";
import WhiteLogo from "../../assets/WhiteLogo.png";
import contactImg from "../../assets/contact.png";
import { Link } from "react-scroll";
import Menu from "../../assets/menu.png";

const NavBar = () => {
  const [showMenu, setShowMenu] = useState(false);

  const scrollToTop = (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="navBar">
      <a href="#top" className='logoLink' onClick={scrollToTop}>
        <img src={WhiteLogo} alt="logo" className='logo' />
      </a>
      <div className="desktopMenu">
        <Link activeClass="active" to='intro' spy={true} smooth={true} offset={-80} duration={500} className="desktopMenuListItem">Home</Link>
        <Link activeClass="active" to='about' spy={true} smooth={true} offset={-30} duration={500} className="desktopMenuListItem">About</Link>
        <Link activeClass="active" to='works' spy={true} smooth={true} offset={-80} duration={500} className="desktopMenuListItem">Portfolio</Link>
        <Link activeClass="active" to='skills' spy={true} smooth={true} offset={-80} duration={500} className="desktopMenuListItem">Skills</Link>
      </div>
      <Link to="contact" spy={true} smooth={true} offset={-70} duration={500} className="desktopMenuBtn">
        <img src={contactImg} alt="" className="desktopMenuImg" />Contact Me
      </Link>
      <img src={Menu} alt="Menu" className='mobMenu' onClick={() => setShowMenu(!showMenu)} />
      <div className="navMenu" style={{ display: showMenu ? 'flex' : 'none' }}>
        <Link activeClass="active" to='intro' spy={true} smooth={true} offset={-80} duration={500} className="listItem" onClick={() => setShowMenu(false)}>Home</Link>
        <Link activeClass="active" to='about' spy={true} smooth={true} offset={-30} duration={500} className="listItem" onClick={() => setShowMenu(false)}>About</Link>
        <Link activeClass="active" to='works' spy={true} smooth={true} offset={-80} duration={500} className="listItem" onClick={() => setShowMenu(false)}>Portfolio</Link>
        <Link activeClass="active" to='skills' spy={true} smooth={true} offset={-80} duration={500} className="listItem" onClick={() => setShowMenu(false)}>Skills</Link>
      </div>
    </nav>
  );
}

export default NavBar;